import constant from './constant/appConstant'

import { ApiAdaptater } from './adapter/adaptaters'
import { QbAjaxRequest } from './qbrequest'
import { ArcxpAjaxRequest, ARC_XP_URLS } from './arcxprequest'



export class QbBusiness {
	static isOnline = true

	static reduxDispatch = () => {
	}
	static on404 = () => {
	}
	static onConnectModeChanged = () => {
	}

	static setReduxDispatcher = d => {
		QbBusiness.reduxDispatch = d
	}
	static setCallbackOnConnectModeChanged = callback => {
		QbBusiness.onConnectModeChanged = callback
	}
	static setCallbackOnErrorModeChanged = callback => {
		QbBusiness.on404 = callback
	}

	static setOnline() {
		if (this.isOnline === false) {
			this.isOnline = true
			this.onConnectModeChanged(this.isOnline)
		}
	}

	static setOffline() {
		if (this.isOnline === true) {
			this.isOnline = false
		}
		this.onConnectModeChanged(this.isOnline)
	}

	static returnError(msg, code, fieldsErrors) {
		const c = code || constant.businessLayer.code.badParameters
		let r
		if (fieldsErrors) {
			r = {
				status: 'error',
				c,
				message: msg,
				fieldsErrors
			}
		} else {
			r = {
				status: 'error',
				c,
				message: msg
			}
		}
		return r
	}

	/** *********************************************************/
	/** ************* DEFINITION DES CONTROLLERS ****************/
	/** *********************************************************/

	// Couples objects/méthodes disponibles ici : https://github.com/Qobuz/api-documentation

	// test de l'api
	static _promiseHandleConnect(promise, display404 = true) {
		const self = this
		return promise
			.then(r => {
				if (r.code === 404 && display404) {
					// not found
					self.on404()
				}
				self.setOnline()
				return r
			})
			.catch(e => {
				if (e.toString().indexOf('Failed to fetch') > -1) {
					// déconnecté
					self.setOffline()
				} else {
					// erreur 500
					self.on404()
				}
			})
	}


	// Report Streaming End
	static reportStreamingEnd(events) {
		const self = this
		let r
		if (events) {
			const eventsCopy = []
			// complete events avec user_id, device_id, credential_id
			for (let i = 0; i < events.length; i++) {
				if (events[i].duration > 0) {
					const e = {
						...Object.assign({}, events[i]),
						user_id: localuser.id,
						device_id: localuser.deviceId,
						credential_id: localuser.credentialId
					}
					delete e.reportIndex
					eventsCopy.push(e)
				}
			}
			if (eventsCopy.length > 0) {
				r = QbAjaxRequest.post(
					'track',
					'reportStreamingEnd',
					{
						events: JSON.stringify(eventsCopy)
					}
				)
			} else {
				r = Promise.resolve({
					status: 'success'
				})
			}
		} else {
			// sinon on retourne juste les datas dont on a besoin pour la page de login
			r = Promise.resolve(self.returnError('Please set events', constant.businessLayer.code.badParameters))
		}
		return r
	}

	// Report Streaming Start
	static reportStreamingStart(events) {
		const self = this
		let r
		if (events) {
			const eventsCopy = []
			// complete events avec user_id, device_id, credential_id
			for (let i = 0; i < events.length; i++) {
				const e = {
					...Object.assign({}, events[i]),
					user_id: localuser.id,
					device_id: localuser.deviceId,
					credential_id: localuser.credentialId,
					duration: 0
				}
				delete e.reportIndex
				eventsCopy.push(e)
			}

			r = QbAjaxRequest.post(
				'track',
				'reportStreamingStart',
				{
					events: JSON.stringify(eventsCopy)
				}
			)
		} else {
			// sinon on retourne juste les datas dont on a besoin pour la page de login
			r = Promise.resolve(self.returnError('Please set events', constant.businessLayer.code.badParameters))
		}
		return r
	}

	// Controller pour récupérer un titre

	static trackGet(trackId, formatId, intent, ignoreHandleConnect) {
		let r
		if (trackId) {
			if (ignoreHandleConnect) {
				r = QbAjaxRequest.get(
					'track',
					'getFileUrl',
					{
						track_id: trackId,
						format_id: formatId || 5,
						intent
					},
					true,
					true
				)
			} else {
				r = this._promiseHandleConnect(
					QbAjaxRequest.get(
						'track',
						'getFileUrl',
						{
							track_id: trackId,
							format_id: formatId || 5,
							intent
						},
						true,
						true
					)
				)
			}
		} else {
			// sinon on retourne juste les datas dont on a besoin pour la page de login
			r = Promise.resolve(self.returnError('Please set a track Id', constant.businessLayer.code.badParameters))
		}
		return r
	}

	// Controller pour récupérer les status des pistes

	static trackGetStatus(tracks) {
		let r
		if (tracks) {
			r = this._promiseHandleConnect(
				QbAjaxRequest.get(
					'track',
					'getFileStatuses',
					{
						files: JSON.stringify(tracks)
					},
					true
				)
			)
		} else {
			// sinon on retourne juste les datas dont on a besoin pour la page de login
			r = Promise.resolve(self.returnError('Please set tracks', constant.businessLayer.code.badParameters))
		}
		return r
	}

	// Récupération d'un album à partir d'un id
	// 		offset et limit servent a limiter les tracks au sein de lalbum

	static getAlbum(id, offset, limit, extra, display404 = true) {

		const args = {
			album_id: id,
			offset,
			limit
		}
		if (extra) {
			args.extra = extra
		}
		const log = QbAjaxRequest.get('album', 'get', args, false, true)
		return this._promiseHandleConnect(
			log.then(r => {
				let response
				if (!r.status) {
					// si pas derreur
					response = ApiAdaptater.singleAlbum(r)
				} else {
					response = r
				}
				return response
			}), display404
		)
	}

	// Récupération d'une playlist à partir d'un id

	static getPlaylist(id, extra, offset, limit) {

		const log = QbAjaxRequest.get(
			'playlist',
			'get',
			{
				playlist_id: id,
				extra,
				offset: offset || 0,
				limit: limit || 50
			},
			false,
			true
		)
		return this._promiseHandleConnect(
			log.then(r => {
				let response
				if (!r.status) {
					// si pas derreur
					response = ApiAdaptater.singlePlaylist(r)
				} else {
					response = r
				}
				return response
			})
		)
	}

	// Récupération d'un artist à partir d'un id

	static getArtist(id, extra, offset, limit) {

		const log = QbAjaxRequest.get(
			'artist',
			'get',
			{
				artist_id: id,
				extra,
				offset: offset || 0,
				limit: limit || 25
			},
			false,
			true
		)
		return this._promiseHandleConnect(
			log.then(r => {
				let response
				if (!r.status) {
					// si pas derreur
					response = ApiAdaptater.singleArtist(r)
				} else {
					response = r
				}
				return response
			})
		)
	}

	// Récupération des articles associés à l'id d'un artist
	// limit sert a limiter le nombre d'articles retournés

	static getArtistArticles(artistId, offset, limit) {

		return QbAjaxRequest.get(
			'article',
			'listArticles',
			{
				artist_id: artistId,
				offset,
				limit
			},
			false,
			true
		)
	}

	// Récupération des artistes similaires à partir d'un id

	static getSimilarArtists(id, offset, limit) {
		return this._promiseHandleConnect(
			QbAjaxRequest.get(
				'artist',
				'getSimilarArtists',
				{
					artist_id: id,
					offset,
					limit
				},
				false,
				true
			)
		)
	}

	// Récupération d'un track à partir d'un id

	static getTrack(id) {

		const log = QbAjaxRequest.get(
			'track',
			'get',
			{
				track_id: id
			},
			false,
			true
		)
		return this._promiseHandleConnect(
			log.then(r => {
				let response
				if (!r.status) {
					// si pas derreur
					response = ApiAdaptater.singleTrack(r)
				} else {
					response = r
				}
				return response
			})
		)
	}

	/**
	 * All the 'GET' operations in User Library
	 * @param domain the domain where you will do the operations
	 * @param method the specified method to call
	 * @param optionalParameters optional parameters that depend on the method
	 * @returns {*}
	 */
	static getUserLibrary(domain, method, optionalParameters, ignoreHandleConnect, cachedisabled) {
		const cache = !cachedisabled

		let parameters = optionalParameters
		if (!optionalParameters) {
			parameters = {}
		}
		parameters.user_id = user.id

		return ignoreHandleConnect ?
			QbAjaxRequest.get(domain, method, parameters, false, cache) :
			this._promiseHandleConnect(QbAjaxRequest.get(domain, method, parameters, false, cache))

	}

	/** *********************************************************/
	/** *********** FIN DEFINITION DES CONTROLLERS **************/
	/** *********************************************************/

	// Récupération des albums similaires à partir de l'id d'un album
	// limit sert a limiter le nombre d'albums retournés

	static getSimilarAlbum(genreId, type, offset, limit) {

		return QbAjaxRequest.get(
			'album',
			'getFeatured',
			{
				genre_id: genreId,
				type,
				offset,
				limit
			},
			false,
			true
		)
	}

	// Récupération des articles associés à l'id d'un album
	// limit sert a limiter le nombre d'articles retournés

	static getAlbumArticles(albumId, offset, limit) {

		return QbAjaxRequest.get(
			'article',
			'listArticles',
			{
				album_id: albumId,
				offset,
				limit
			},
			false,
			true
		)
	}

	// Récupération des playlists similaires à partir d'un id
	static getSimilarPlaylist(genresId, type, offset, limit) {

		return QbAjaxRequest.get(
			'playlist',
			'getFeatured',
			{
				genres_id: genresId,
				type,
				offset,
				limit
			},
			false,
			true
		)
	}

	// Récupération des données pour la page Home
	static getGenreData() {
		return this._promiseHandleConnect(QbAjaxRequest.get('genre', 'list', {}, false, true))
	}

	static getStore() {
		if (ArcxpAjaxRequest.getStore()) return Promise.resolve()
		return QbAjaxRequest.getStore().then(store => {
			ArcxpAjaxRequest.setStore(store)
		})
	}

	static getStory(id, type = 'story') {
		return this.getStore().then(
			() => this._promiseHandleConnect(ArcxpAjaxRequest.get(ARC_XP_URLS.getStory, { id, type }))
		)
	}

	static getEverydayDataByRubric(rubricId, genreId, offset, limit) {

		const args = {
			offset,
			limit
		}

		if (rubricId) {
			args.rubric_ids = rubricId
		}

		if (genreId) {
			args.genre_ids = genreId
		}

		return this._promiseHandleConnect(QbAjaxRequest.get('article', 'listLastArticles', args, false, true))
	}

	static getFeaturedAlbumByTypeDataAndGenre(type, genreId, offset, limit) {
		const args = {
			type,
			offset,
			limit
		}

		// L'API ne gère pas de paramètre genreId vide, contrairement aux autres paramètres...
		if (genreId) {
			const argsGenre = {
				genre_ids: genreId
			}
			Object.assign(args, argsGenre)
		}

		return this._promiseHandleConnect(QbAjaxRequest.get('album', 'getFeatured', args, false, true))
	}

	static getFeaturedAlbumByTypeData(type, offset, limit) {

		return this._promiseHandleConnect(
			QbAjaxRequest.get(
				'album',
				'getFeatured',
				{
					type,
					offset,
					limit
				},
				false,
				true
			)
		)
	}

	static getMoreFocusData(genreId, offset, limit) {
		const args = {
			offset,
			limit
		}
		if (genreId) {
			const argsGenre = {
				genre_ids: genreId
			}
			Object.assign(args, argsGenre)
		}
		return this._promiseHandleConnect(QbAjaxRequest.get('focus', 'list', args, false, true))
	}

	static getHomeData(genreIds) {
		let r
		if (genreIds) {
			r = this._promiseHandleConnect(
				QbAjaxRequest.get(
					'featured',
					'index',
					{
						genre_ids: genreIds
					},
					false,
					true
				)
			)
		} else {
			r = this._promiseHandleConnect(QbAjaxRequest.get('featured', 'index', {}, false, true))
		}
		return r
	}

	// Récupération des données pour la page Featured Playlists
	static getPlaylistDataByAllTheme(genreIds) {
		let r
		if (genreIds) {
			r = this._promiseHandleConnect(
				QbAjaxRequest.get(
					'featured',
					'playlists',
					{
						genre_ids: genreIds
					},
					false,
					true
				)
			)
		} else {
			r = this._promiseHandleConnect(QbAjaxRequest.get('featured', 'playlists', {}, false, true))
		}
		return r
	}

	// Récupération des données pour la page Featured Albums
	static getFeaturedAlbumData(genreIds) {
		let r
		if (genreIds) {
			r = this._promiseHandleConnect(
				QbAjaxRequest.get(
					'featured',
					'albums',
					{
						genre_ids: genreIds
					},
					false,
					true
				)
			)
		} else {
			r = this._promiseHandleConnect(QbAjaxRequest.get('featured', 'albums', {}, false, true))
		}
		return r
	}

	static getEverydayDataByAllRubric(genreIds) {
		let r
		if (genreIds) {
			r = this._promiseHandleConnect(
				QbAjaxRequest.get(
					'featured',
					'everyday',
					{
						genre_ids: genreIds
					},
					false,
					true
				)
			)
		} else {
			r = this._promiseHandleConnect(QbAjaxRequest.get('featured', 'everyday', {}, false, true))
		}
		return r
	}

	static getExploreData(genreIds) {
		let r
		if (genreIds) {
			r = this._promiseHandleConnect(
				QbAjaxRequest.get(
					'featured',
					'explore',
					{
						genre_ids: genreIds
					},
					false,
					true
				)
			)
		} else {
			r = this._promiseHandleConnect(QbAjaxRequest.get('featured', 'explore', {}, false, true))
		}
		return r
	}

	static getArticleByRubricData(rubricId, genreId, offset, limit) {
		const args = {
			rubric_ids: rubricId,
			offset,
			limit
		}

		// L'API ne gère pas de paramètre genreId vide, contrairement aux autres paramètres...
		if (genreId) {
			const argsGenre = {
				genre_ids: genreId
			}
			Object.assign(args, argsGenre)
		}


		return this._promiseHandleConnect(QbAjaxRequest.get('article', 'listLastArticles', args, false, true))
	}

	// Récupération des playlists relatives à un thème
	static getPlaylistDataByTheme(type, tags, genreId, offset, limit) {
		const args = {
			type,
			tags,
			offset,
			limit
		}

		// L'API ne gère pas de paramètre genreId vide, contrairement aux autres paramètres...
		if (genreId) {
			const argsGenre = {
				genre_ids: genreId
			}
			Object.assign(args, argsGenre)
		}

		return this._promiseHandleConnect(QbAjaxRequest.get('playlist', 'getFeatured', args, false, true))
	}

	static getAlbumByTypeAndGenre(type, genreId, offset, limit) {
		const args = {
			type,
			offset,
			limit
		}

		// L'API ne gère pas de paramètre genreId vide, contrairement aux autres paramètres...
		if (genreId) {
			const argsGenre = {
				genre_ids: genreId
			}
			Object.assign(args, argsGenre)
		}

		return this._promiseHandleConnect(QbAjaxRequest.get('album', 'getFeatured', args, false, true))
	}
}



// WEBPACK FOOTER //
// ./src/utils/business/qbbusiness.js